import Axios from 'axios';
import { getPresignedUrl } from '../../common/constants/api';

export const UploadFile = (id, data, Upload_ok, Upload_not_ok) => {
  const file = document.getElementById(id);

  function sendFile(file_by_id, baseApi) {
    let file_ = file_by_id.files[0];

    Axios.put(baseApi.url, file_, {
      headers: {
        'Content-Type': 'application/octet-stream'
      }
    })
      .then(res => {
        if (res.status == 200) {
          // alert('Document Successfully uploaded')
          Upload_ok(baseApi);
        } else {
          // alert('!!Some Error occured while uploading document');
          Upload_not_ok(res.status);
          file_.value = '';
          return false;
        }
      })
      .catch(err => {
        Upload_not_ok(err);
        file_.value = '';
      });
  }
  // Call the  API for getting a signed URL (Step 1)

  getPresignedUrl(data)
    .then(data => {
      let baseApi = data;
      sendFile(file, baseApi);
    })
    .catch(err => {
      Upload_not_ok(id);
    });
};
